var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.85 9.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico Mail") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.14,0H1.71A1.71,1.71,0,0,0,0,1.71V7.6A1.71,1.71,0,0,0,1.71,9.31h8.43A1.71,1.71,0,0,0,11.85,7.6V1.71A1.71,1.71,0,0,0,10.14,0m0,.82.2,0-3.56,4a1.15,1.15,0,0,1-1.72,0L1.51.84l.2,0ZM11,7.6a.89.89,0,0,1-.89.89H1.71A.89.89,0,0,1,.82,7.6V1.71a.88.88,0,0,1,.07-.34l3.57,4a2,2,0,0,0,2.95,0l3.57-4a.88.88,0,0,1,.07.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMail);
export default __webpack_public_path__ + "static/media/ico-mail.55b7a5d861f1ca21b9a81cedc5db9cb0.svg";
export { ForwardRef as ReactComponent };